export var VideoPreviewEvent;
(function (VideoPreviewEvent) {
    VideoPreviewEvent["PlayerRendered"] = "player_rendered";
    VideoPreviewEvent["FirstClickPlay"] = "first_click_play";
    VideoPreviewEvent["MediaError"] = "media_error";
    VideoPreviewEvent["ChangePlaybackRate"] = "change_playback_rate";
    VideoPreviewEvent["ChangeVideoQuality"] = "change_video_quality";
    VideoPreviewEvent["ClosePreview"] = "close_preview";
    VideoPreviewEvent["TimeToBuffer"] = "time_to_buffer";
    VideoPreviewEvent["TimeToLoad"] = "time_to_load";
    VideoPreviewEvent["SeekVideo"] = "seek_video";
    VideoPreviewEvent["VideoStartsPlaying"] = "video_starts_playing";
    VideoPreviewEvent["VideoResumesPlaying"] = "video_resumes_playing";
    VideoPreviewEvent["VideoStalled"] = "video_stalled";
    VideoPreviewEvent["VideoStalledResume"] = "video_stalled_resume";
    VideoPreviewEvent["VideoPaused"] = "video_paused";
    VideoPreviewEvent["ScrubberThumbnailsLoaded"] = "scrubber_thumbnails_loaded";
    VideoPreviewEvent["ScrubberThumbnailsFailed"] = "scrubber_thumbnails_failed";
    VideoPreviewEvent["HoverScrubberThumbnailsSucceeded"] = "hover_scrubber_thumbnails_succeeded";
    VideoPreviewEvent["HoverScrubberThumbnailsFailed"] = "hover_scrubber_thumbnails_failed";
    VideoPreviewEvent["AudioWaveformLoaded"] = "audio_waveform_loaded";
    VideoPreviewEvent["AudioWaveformFailed"] = "audio_waveform_failed";
    VideoPreviewEvent["VideoPlaybackSmoothness"] = "video_playback_smoothness";
    VideoPreviewEvent["VideoMetadataLoaded"] = "video_metadata_loaded";
    // These are the events that are logged in video_playback_smoothness' extra field. We split them out as their own
    // events so they can stand on their own in AMIS.
    VideoPreviewEvent["TimeToFirstFrame"] = "time_to_first_frame";
    VideoPreviewEvent["StallsPerSecondOfPlayback"] = "num_stalls_per_second_playback";
    VideoPreviewEvent["TotalStallDurationOverTotalPlaybackDuration"] = "total_stall_duration_over_total_playback_duration";
    VideoPreviewEvent["DroppedVideoFrames"] = "dropped_video_frames";
    // Event logged if the user plays 2% of more of the video
    VideoPreviewEvent["VideoProgress2Percent"] = "video_progress_2_percent";
    // Event logged if the user plays 1 second or more of the video
    VideoPreviewEvent["VideoProgress1Second"] = "video_progress_1_second";
    VideoPreviewEvent["DroppedVideoFramesOverTotalVideoFrames"] = "dropped_video_frames_over_total_video_frames";
    VideoPreviewEvent["NetworkBandwidthBytesPerSecond"] = "network_bandwidth_bytes_per_second";
    VideoPreviewEvent["PlayDurationMs"] = "play_duration_ms";
    VideoPreviewEvent["HasMultipleAudioTracks"] = "has_multiple_audio_tracks";
})(VideoPreviewEvent || (VideoPreviewEvent = {}));
//# sourceMappingURL=video.preenvesnextjs.map
